import axios from '../config.js';
const resource = '/password';

export default {
  /**
   * Request for password reset
   * @param {String} email - change pass link/info will be sent here
   */
  reset(email) {
    const data = {
      email: email
    }
    return axios.post(`${resource}/reset`, data);
  },

  /**
   * Actual change password
   * @param {Object} data - needed info from email
   */
  change(data) {
    return axios.post(`${resource}/change`, data);
  },
};